<template>
  <div>
    <div class="d-flex justify-content-between">
      <h4 class="d-flex align-items-center">
        <feather-icon class="mr-50" size="20" icon="CalendarIcon" />
        
        الخطة السنوية لسنة {{data.year }}
      </h4>
      <h4 class="d-flex align-items-center" v-if='!file'>
        
        رقم و تاريخ اجتماع مجلس الإدارة {{ data.meeting_minute_id ? data.meeting_minute_id.meeting_minutes_label : '' }}
      </h4>
    </div>
    <hr />
    <div>
      <treat-plan-table
          :planDetails="planDetails"
          :isArchived="data.year !== new Date().getFullYear().toString()"
          :evaluated.sync="evaluated"
      />
    </div>
    <div class="d-flex justify-content-between mt-2">
      <h4 class="d-flex align-items- center">
        <feather-icon class="mr-50" size="20" icon="CalendarIcon" />
        الأنشطة الطارئة
      </h4>
    </div>
    <hr />
    <treat-plan-table
        :planDetails="urgentActivty"
        isUrgent
        :isArchived="data.year !== new Date().getFullYear().toString()"
        :evaluated.sync="evaluated"
    />
    <b-row v-if="file">

      <b-col cols="4">
        <div class="info-card px-2 py-1 my-1">
        <div class="d-flex align-items-center justify-content-between">
            <div>
            ملف محضر الجلسة الإدارية {{ data.meeting_minute_id ? data.meeting_minute_id.meeting_minutes_label : ''  }} 
            </div>
            <div>
            <b-button
            
                variant="flat-info"
                v-b-toggle.doc-view
                class="btn-icon mx-25"
                v-b-tooltip.hover.v-info.bottom
                title="عرض المستند المرفوع"
                :to="{ name: 'file-view', query: { ep:file  } }"
            >
                <feather-icon icon="EyeIcon"
            /></b-button>
            </div>
        </div>
        <div>
            <hr />
        </div>
        </div>
      </b-col> 
    </b-row>

  </div>
</template>
<script>
import TreatPlanTable from "../../../annual-plan/components/TreatPlanTable.vue";
import axios from "@axios";
  
  import router from "@/router";
import {
  BRow,
  BCol,
  BFormCheckbox,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  VBTooltip,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    TreatPlanTable,
    BCol,
    BFormCheckbox,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormRadio,
    BForm,
    BFormTextarea,
    BButton,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    transactionRequestData: Array ,
    data : Object ,
  },
  data() {
    return {
      historyModal: false,
      editForm: {},
      editModal: false,
      activityName: null,
      evaluated: false,
      
      file: '',
    };
  },
  computed: {
    activePlan() {
      const year = parseInt(this.transactionRequestData.year); // Extract the year value

      if (year === new Date().getFullYear()) {
        return this.transactionRequestData;
      } else {
        var target = this.archivedPlans.find((el) => {
          return el.year.toString() === year.toString();
        });
        var x = [];
        x = target.transactionRequestData;
        return x;
      }
    },
    planDetails(){
      if (this.data.hasOwnProperty('data')){
        return this.data.data.filter(item => item['program_id']['id'] != 'undefined')
      }
      

    },
    urgentActivty(){
      if (this.data.hasOwnProperty('data')){
        return this.data.data.filter(item => item['program_id']['id'] == 'undefined')
      }

    },
  },
    methods :{

        async handleDataChange(data) {
            if(data) {
              const currentRoute = router.currentRoute.path.includes('ministry')
            if(currentRoute){
                await axios.get(`v2/ministry/ngo-meeting-minutes/${this.data.meeting_minute_id.id}`).then((res) => this.file=res.data.data.file);
            }
            else{
                this.file=null
            }
          }

        }
    },
    
    async mounted() {  
        this.handleDataChange(this.data)
    },  
    watch: {
        data: {
        handler: async function(newVal, oldVal) {
            await this.handleDataChange(this.data)
        },
        deep: true
        }
    },
};
</script>
